/**
 * Bundler Sticky Mobile - Intersection Observer
 *
 * Controla la visibilidad del elemento .bndlr-mnm-second-container en mobile.
 * Solo aparece fijo al pie de la página cuando .bndlr-products-container
 * está visible en el viewport, con una animación de fade suave.
 *
 * Incluye toggle bar para colapsar/expandir el carrito en mobile.
 *
 * NOTA: Usa MutationObserver para esperar a que Bundler cargue sus elementos de forma asíncrona.
 */

(function() {
  'use strict';

  // Configuración
  var MOBILE_BREAKPOINT = 768;
  var OBSERVER_THRESHOLD = 0.1;

  // Elementos del DOM
  var productsContainer = null;
  var secondContainer = null;
  var toggleBar = null;
  var intersectionObserver = null;
  var mutationObserver = null;
  var isMobile = false;
  var lastProductCount = 0;

  /**
   * Verifica si estamos en mobile
   */
  function checkIfMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  /**
   * Crea la barra de toggle para mobile
   */
  function createToggleBar() {
    toggleBar = document.createElement('div');
    toggleBar.className = 'bndlr-mobile-toggle';
    toggleBar.innerHTML = '<span class="bndlr-toggle-info"><span class="bndlr-toggle-text">Your Bundle</span></span><span class="bndlr-toggle-icon">▲</span>';
    return toggleBar;
  }

  /**
   * Maneja el click en el toggle
   */
  function handleToggleClick(e) {
    e.stopPropagation();
    if (secondContainer) {
      secondContainer.classList.toggle('is-collapsed');
    }
  }

  /**
   * Expande el container (quita is-collapsed)
   */
  function expandContainer() {
    if (secondContainer) {
      secondContainer.classList.remove('is-collapsed');
    }
  }

  /**
   * Cuenta productos en el bundle - intenta varios selectores
   */
  function countProducts() {
    if (!secondContainer) return 0;
    // Intentar varios selectores posibles de Bundler
    var items = secondContainer.querySelectorAll('.bndlr-mnm-selected-product, .bndlr-selected-product, .bndlr-mnm-selected-products > div');
    console.log('Bundler products found:', items.length);
    return items.length;
  }

  /**
   * Callback del Intersection Observer
   */
  function handleIntersection(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (secondContainer) {
        if (entry.isIntersecting) {
          secondContainer.classList.add('is-visible');
        } else {
          secondContainer.classList.remove('is-visible');
        }
      }
    }
  }

  /**
   * Inicializa el Intersection Observer
   */
  function initIntersectionObserver() {
    intersectionObserver = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: OBSERVER_THRESHOLD
    });

    if (productsContainer) {
      intersectionObserver.observe(productsContainer);
    }
  }

  /**
   * Destruye el Intersection Observer
   */
  function destroyIntersectionObserver() {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }

    if (secondContainer) {
      secondContainer.classList.remove('is-visible');
    }
  }

  /**
   * Inicializa la funcionalidad cuando los elementos están disponibles
   */
  function setupBundlerSticky(products, second) {
    productsContainer = products;
    secondContainer = second;

    console.log('Bundler Sticky Mobile: Elementos encontrados, inicializando...');

    isMobile = checkIfMobile();

    if (isMobile) {
      // Crear toggle bar
      var toggle = createToggleBar();
      secondContainer.insertBefore(toggle, secondContainer.firstChild);
      toggle.addEventListener('click', handleToggleClick);

      // Inicializar intersection observer
      initIntersectionObserver();

      // Auto-open: revisar cada 500ms si se agregó un producto
      lastProductCount = countProducts();
      var lastContentLength = secondContainer.innerHTML.length;

      setInterval(function() {
        var current = countProducts();
        var currentLength = secondContainer.innerHTML.length;

        // Si hay más productos O el contenido creció significativamente
        if (current > lastProductCount || currentLength > lastContentLength + 100) {
          expandContainer();
        }
        lastProductCount = current;
        lastContentLength = currentLength;
      }, 400);
    }

    // Listener para resize
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 250);
    });
  }

  /**
   * Espera a que los elementos de Bundler aparezcan en el DOM
   */
  function waitForBundlerElements(callback) {
    var products = document.querySelector('.bndlr-products-container');
    var second = document.querySelector('.bndlr-mnm-second-container');

    if (products && second) {
      callback(products, second);
      return;
    }

    console.log('Bundler Sticky Mobile: Esperando a que los elementos de Bundler se carguen...');

    mutationObserver = new MutationObserver(function() {
      var products = document.querySelector('.bndlr-products-container');
      var second = document.querySelector('.bndlr-mnm-second-container');

      if (products && second) {
        console.log('Bundler Sticky Mobile: Elementos detectados!');
        mutationObserver.disconnect();
        mutationObserver = null;
        callback(products, second);
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function() {
      if (mutationObserver) {
        console.warn('Bundler Sticky Mobile: Timeout - Los elementos de Bundler no se cargaron en 10 segundos');
        mutationObserver.disconnect();
        mutationObserver = null;
      }
    }, 10000);
  }

  /**
   * Inicializa o destruye según si estamos en mobile
   */
  function handleResize() {
    var wasMobile = isMobile;
    isMobile = checkIfMobile();

    if (wasMobile !== isMobile) {
      if (isMobile) {
        initIntersectionObserver();
      } else {
        destroyIntersectionObserver();
      }
    }
  }

  /**
   * Inicializa el script
   */
  function init() {
    console.log('Bundler Sticky Mobile: Iniciando...');
    waitForBundlerElements(setupBundlerSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
